export default __webpack_public_path__ + "static/media/express.7e85c513.svg";